import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d4d625c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "apply-invoice-handle van-hairline--top" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "发票已申请", -1))

import { Button } from 'vant'
import { withDefaults } from 'vue'
import { commonErrorHandle } from '@/utils/error-handle'
import { getInsuranceDetailInfo } from '@/apis/insurance'
import { clearToast, showToastLoading, showConfirmModal } from '@/utils/tools'
import appHost from '@/utils/app'


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-apply-check',
  props: {
    guid: { default: '' },
    time: { default: '' },
    orderNo: { default: '' },
    url: { default: '' }
  },
  setup(__props: any) {

const props = __props as { guid: string, time: string, orderNo: string, url: string };



async function checkInvoiceHadnle() {
  if(props.url) {
    appHost.openBrowser(props.url)
    return
  }
  showToastLoading()
  try {
    const data = await getInsuranceDetailInfo(props.guid)
    console.log('data', data)
    clearToast()
    if (!data || !data.pdf_url) {
      showConfirmModal({
        title: '提示',
        message: `订单${props.orderNo}已申请开票，发票开具中，请稍后尝试!`,
        confirmButtonText: '知道了',
        className: 'nongfu-dialog-confirm-class',
        showCancelButton: false,
      })
    } else {
      appHost.openBrowser(data.pdf_url)
    }
  } catch (error) {
    commonErrorHandle(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, _toDisplayString(__props.time), 1)
    ]),
    _createVNode(_unref(Button), {
      class: "check-invoice",
      size: "small",
      type: "success",
      plain: "",
      onClick: checkInvoiceHadnle
    }, {
      default: _withCtx(() => [
        _createTextVNode("查看发票")
      ]),
      _: 1
    })
  ]))
}
}

})